<script>
export default {
  name: 'BouncingDots',
};
</script>

<template>
  <div class="inline-flex">
    <span class="animate-bounce">.</span>
    <span class="animate-bounce animation-delay-200">.</span>
    <span class="animate-bounce animation-delay-400">.</span>
  </div>
</template>

<style>
  .animation-delay-200 {
    animation-delay: 0.05s;
  }
  .animation-delay-400 {
    animation-delay: 0.1s;
  }
</style>
